import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { BlobServiceClient } from '@azure/storage-blob';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import Container from 'common/src/components/UI/Container';
import { countrycodes } from './CountryCodes';

const GlobalWrapper = styled.div`
  background: #f6f8fd;

  .title {
    font-size: 22px;
    @media (min-width: 992px) {
      font-size: 36px;
    }
    padding: 20px;
  }

  .intro{
    padding: 10px 20px;
    text-align: center;
    line-height: 1.5;
    font-size: 14px;
    @media (min-width: 992px) {
      font-size: 18px;
    }
  }

  .show-status{
    padding: 0 20px;
    label{
      font-size: 15px;
      font-weight: 600;
      text-transform: uppercase;
    }
  }

  .check-status{
    padding: 0 20px;
    text-align:right;

    .err-msg{
      padding:5px;
      font-size: 13px;
    }

    button{
      background: linear-gradient(
        180deg,
        #ffffff 0%,
        rgba(255, 255, 255, 0) 100%
      ),
      #aaabbb;
      font-weight: 600;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      padding: 10px;

      @media (min-width: 992px) {
        padding: 10px 30px;
      }
      border: 1px solid #ccc;
      cursor: pointer;

      &:active {
        box-shadow: none;
      }
      &.ml-2{
        margin-left:5px;
      }

      &:disabled{
        cursor: not-allowed;
      }
    }

    .text-email{
      @media (min-width: 992px) {
        width: 250px;
      }

      width: auto;
      border: 1px solid #ccc;
      border-radius: 5px;
      padding: 10px;
      background: #fff;
      margin-right: 10px;
    }
  }

  .sub-title {
    font-size: 18px;
    @media (min-width: 992px) {
      font-size: 26px;
    }
    padding: 20px;
  }

  .content {
    padding: 15px;

    .line {
      display: flex;
      flex-wrap: wrap;

      .control {
        flex-grow: 1;
        flex-basis: 0;
        min-width: 90%;

        @media (min-width: 992px) {
          min-width: 300px;
        }
        margin: 10px 15px;

        label {
        }

        .text-ctrl {
          margin-top: 5px;
          width: 100%;
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 10px;
          background: #fff;

          &:disabled{
            background: #eaeaea;
            cursor: not-allowed;
          }

          &.r-select{
            
              padding: 0;
              width: 150;
              border: none;
          
          }
        }

        input[type='file'].text-ctrl {
          padding: 7px;
          height: 38px !important;
        }

        .group {
          display: flex;

          .joint {
            width: 100px;
            margin-right: 10px;
          }
        }

        button {
          background: linear-gradient(
              180deg,
              #ffffff 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            #aaabbb;
          font-weight: 600;
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          padding: 10px 30px;
          border: 1px solid #ccc;
          cursor: pointer;
          margin-top: 22px;

          &:active {
            box-shadow: none;
          }

          &:disabled{
            cursor: not-allowed;
          }

         
        }

        ul {
          li {
            background: #fff;
            box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
            display: flex;
            justify-content: space-between;
            padding: 10px;
            border-radius: 5px;
            margin-bottom: 10px;
            font-size: 14px;

            .close {
              cursor: pointer;
              padding: 5px;
            }

            .head {
              margin-bottom: 5px;
              text-transform: uppercase;
              color: #a1a1a1;
              font-size: 12px;
            }
          }
        }

        .file-uploaded {
          background: #fff;
          box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
          display: flex;
          justify-content: space-between;
          padding: 10px;
          border-radius: 5px;
          font-size: 14px;
          margin-top: 5px;
        }
      }
    }

    .line-check {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 5px;
      padding: 0 15px;
      min-height: 35px;
      align-items: center;

      .label-title {
        width: 100%;
        font-weight: 600;
      }

      .label {
        margin-right: 20px;
        width: 150px;
        margin: 5px 0;

        input[type='text'] {
          width: 100%;
          padding: 5px;
          border-radius: 5px;
          border: 1px solid #ddd;
        }
      }

      &.h-auto{
        min-height:auto;
      }
    }
  }

  .divider {
    padding: 20px 0;
    display: flex;
    div {
      width: 50%;
      margin: 0 20px;
      height: 5px;
    }
  }

  .w-auto {
    width: auto !important;
  }import { gcp } from 'common/src/assets/image/charity/clients/2.png';


  .text-center {
    text-align: center;
    padding-bottom:10px;

    button {
      background: linear-gradient(
          180deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0) 100%
        ),
        #aaabbb;
      font-weight: 600;
      font-size: 17px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      padding: 10px 45px;
      border: 1px solid #ccc;
      cursor: pointer;

      &:active {
        box-shadow: none;
      }
    }
  }


  .msg{
    padding:5px;
    text-align: center;
    font-size: 13px;

    &.success-text{
      color:green;
      font-size: 15px;
    }
  
    &.error-text{
      color:red;
    }
  }
 

margin-bottom:10px;
  
`;

const GlobalCitizen = () => {
  const options = [];
  countrycodes.map(ob => {
    options.push({
      label: ob.dial_code,
      value: ob.dial_code,
    });
  });

  const [message, setMessage] = useState({
    success: false,
    msg: '',
  });
  const [loading, setLoading] = useState(false);
  const [upload, setUpload] = useState();
  const [status, setStatus] = useState({
    loading: false,
    email: '',
    errMsg: '',
  });
  const [data, setData] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
    email: '',
    position_applying: '',
    state_other_position: '',
    country_code: '',
    mobile: '',
    whatsapp_number: '',
    password: '',
    address_line1: '',
    address_line2: '',
    city: '',
    state: '',
    country: '',
    zip_code: '',
    linkedin_link: '',
    resume: '',
    windows: false,
    red_hat: false,
    suse: false,
    ubuntu: false,
    centos: false,
    azure: false,
    aws: false,
    gcp: false,
    wan: false,
    aws_nw: false,
    azure_nw: false,
    gcp_nw: false,
    azure_backup: false,
    aws_backup: false,
    gcp_backup: false,
    backup_other: false,
    sql: false,
    oracle: false,
    db2: false,
    open_source: false,
    sap: false,
    oracle_erp: false,
    web: false,
    middleware: false,
    powershell: false,
    ansible: false,
    chef: false,
    terraform: false,
    automation_other: false,
    java: false,
    vb: false,
    html: false,
    backup_other_text: '',
    open_source_text: '',
    automation_other_text: '',
    certifications: [],
  });
  const [list, setList] = useState([]);
  const [cert, setCert] = useState({
    id: '',
    name: '',
  });

  const [is_verify, set_is_verify] = useState(false);

  const [otpShow, setOTPShow] = useState(false);

  const sas = process.env.AZURE_SAS;

  const blobServiceClient = new BlobServiceClient(
    `${process.env.AZURE_BLOB_URL}${sas}`
  );

  // useEffect(() => {
  //   async function main() {
  //     const containerClient = blobServiceClient.getContainerClient(
  //       'flipserveblob'
  //     );

  //     // console.log('ss', containerClient);

  //     // const content = 'Hello world!';
  //     // const blobName = 'newblob' + new Date().getTime();
  //     // const blockBlobClient = containerClient.getBlockBlobClient(blobName);
  //     // const uploadBlobResponse = await blockBlobClient.upload(
  //     //   content,
  //     //   content.length
  //     // );
  //     // console.log(
  //     //   `Upload block blob ${blobName} successfully`,
  //     //   uploadBlobResponse.requestId
  //     // );

  //     let i = 1;
  //     let blobs = containerClient.listBlobsFlat();
  //     for await (const blob of blobs) {
  //       console.log(`Blob ${i++}: ${blob.name}`);
  //     }
  //   }

  //   main();
  // }, []);

  const validateEmail = email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleUpload = async () => {
    const blob = new Blob([upload], { type: upload.type });

    const containerClient = blobServiceClient.getContainerClient(
      process.env.AZURE_BLOB_CONTAINER
    );

    const name_split = upload.name.split('.');
    const blobName = name_split[0] + new Date().getTime() + '.' + name_split[1];
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);
    const uploadBlobResponse = await blockBlobClient.upload(blob, upload.size);

    setData({
      ...data,
      resume: uploadBlobResponse._response.request.url,
    });
  };

  const handleRemove = input => {
    const info = [...list];
    const index = info.indexOf(input);
    info.splice(index, 1);
    setList(info);
  };

  const handleSave = async () => {
    if (data.email) {
      if (!validateEmail(data.email)) {
        setMessage({
          success: false,
          msg: 'Please enter valid email',
        });
        return;
      }
      setLoading(true);
      const input = { ...data };
      input.certifications = [...list];

      try {
        const result = await axios.post(
          `${process.env.REACT_APP_SERVICES_BASE_URL}/application/save`,
          input
        );

        setMessage({
          success: result.data.success,
          msg: result.data.message,
        });

        setLoading(false);

        if (result.data.success) {
          setData({
            first_name: '',
            middle_name: '',
            last_name: '',
            email: '',
            position_applying: '',
            state_other_position: '',
            country_code: '',
            mobile: '',
            whatsapp_number: '',
            password: '',
            address_line1: '',
            address_line2: '',
            city: '',
            state: '',
            country: '',
            zip_code: '',
            linkedin_link: '',
            resume: '',
            windows: false,
            red_hat: false,
            suse: false,
            ubuntu: false,
            centos: false,
            azure: false,
            aws: false,
            gcp: false,
            wan: false,
            aws_nw: false,
            azure_nw: false,
            gcp_nw: false,
            azure_backup: false,
            aws_backup: false,
            gcp_backup: false,
            backup_other: false,
            sql: false,
            oracle: false,
            db2: false,
            open_source: false,
            sap: false,
            oracle_erp: false,
            web: false,
            middleware: false,
            powershell: false,
            ansible: false,
            chef: false,
            terraform: false,
            automation_other: false,
            java: false,
            vb: false,
            html: false,
            backup_other_text: '',
            open_source_text: '',
            automation_other_text: '',
            certifications: [],
          });
        }
      } catch (e) {
        console.log(e);
        setLoading(false);
        setMessage({
          success: false,
          msg: 'Something went wrong',
        });
      }
    } else {
      setLoading(false);
      setMessage({
        success: false,
        msg: 'Please fill the mandatory fields',
      });
    }
  };

  const handleStatusCheck = async () => {
    if (status.email) {
      setStatus({ ...status, loading: true });

      try {
        const result = await axios.post(
          `${process.env.REACT_APP_SERVICES_BASE_URL}/user/landing-verify`,
          { type: 'request', email: status.email }
        );

        if (result.data.success) {
          setOTPShow(true);
          setStatus({
            ...status,
            loading: false,
            errMsg: result.data.message,
            request_id: result.data.request_id,
            otp: '',
          });
        } else {
          setStatus({
            ...status,
            loading: false,
            errMsg: result.data.message,
          });
        }
      } catch (er) {
        console.log(er);
        setStatus({
          ...status,
          loading: false,
          errMsg: 'Something went wrong',
        });
      }
    } else {
      setStatus({ ...status, loading: false, errMsg: 'Email is required' });
    }
  };

  const verifyOTP = async () => {
    if (status.otp) {
      setStatus({ ...status, loading: true });

      try {
        const result = await axios.post(
          `${process.env.REACT_APP_SERVICES_BASE_URL}/user/landing-verify`,
          {
            type: 'verification',
            code: parseInt(status.otp),
            request_id: status.request_id,
          }
        );

        if (result.data.success) {
          setOTPShow(false);
          setStatus({
            ...status,
            loading: false,
            errMsg: result.data.message,
          });
          set_is_verify(true);
          handleGetRecords();
        } else {
          setStatus({
            ...status,
            loading: false,
            errMsg: result.data.message,
          });
        }
      } catch (er) {
        console.log(er);
        setStatus({
          ...status,
          loading: false,
          errMsg: 'Something went wrong',
        });
      }
    } else {
      setStatus({ ...status, loading: false, errMsg: 'Email is required' });
    }
  };

  const handleGetRecords = async () => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_SERVICES_BASE_URL}/application/${status.email}`
      );

      if (result.data.response.data.application_storage.length > 0) {
        const response_data = result.data.response.data.application_storage[0];
        const data_copy = { ...response_data };
        data_copy.certifications = [...data_copy.certification_fk];

        setData(data_copy);

        const _list = [];
        data_copy.certification_fk.map(x =>
          _list.push({
            id: x.certificate_id,
            name: x.certificate_name,
          })
        );
        setList(_list);

        setStatus({
          ...status,
          loading: false,
          errMsg: '',
        });
      } else {
        setStatus({
          ...status,
          loading: false,
          errMsg: 'No records found',
        });
      }
    } catch (er) {
      console.log(er);
      setStatus({
        ...status,
        loading: false,
        errMsg: 'Something went wrong',
      });
    }
  };

  const handleCountryCode = data => {
    setData({ ...data, country_code: data.value });
  };

  return (
    <>
      <Container>
        <Fade bottom casacde>
          <GlobalWrapper>
            <div className="title">Application for Global Citizenship </div>
            <div className="intro">
              FlipServe’s mission is to allow talented IT professionals to
              engage in work on a globally connected platform through the
              concept of a Global Citizenship Model. Professionals located
              anywhere in the world will be allowed to use their skills to
              fulfill an outcome-based completion in the new GiG economy.
            </div>
            <div className="intro">
              Freedom to work from anywhere at your own schedule while
              delivering services to completion.
            </div>
            <div className="intro">
              <b>
                Select your skills and apply for your global certification ship.
                Register and become a FlipServe Associate today!
              </b>
            </div>
            <div className="check-status">
              {otpShow ? (
                <>
                  <input
                    value={status.otp}
                    disabled={is_verify || status.loading}
                    placeholder="Enter your OTP"
                    type="text"
                    className="text-email"
                    maxLength="6"
                    onChange={e => {
                      const re = /^[0-9\b]+$/;
                      if (e.target.value === '' || re.test(e.target.value)) {
                        setStatus({ ...status, otp: e.target.value });
                      }
                    }}
                  ></input>
                  <button
                    onClick={verifyOTP}
                    disabled={is_verify || status.loading}
                  >
                    {status.loading ? 'Loading...' : 'Verify'}
                  </button>
                </>
              ) : (
                <>
                  <input
                    value={status.email}
                    disabled={is_verify || status.loading}
                    placeholder="Email Address"
                    type="text"
                    className="text-email"
                    onChange={e =>
                      setStatus({ ...status, email: e.target.value })
                    }
                  ></input>
                  <button
                    onClick={handleStatusCheck}
                    disabled={is_verify || status.loading}
                  >
                    {status.loading ? 'Loading...' : 'Check Status'}
                  </button>
                </>
              )}

              {is_verify && (
                <button
                  className="ml-2"
                  onClick={() => {
                    setStatus({
                      loading: false,
                      email: '',
                      errMsg: '',
                    });

                    set_is_verify(false);
                    setOTPShow(false);

                    setData({
                      first_name: '',
                      middle_name: '',
                      last_name: '',
                      email: '',
                      position_applying: '',
                      state_other_position: '',
                      country_code: '',
                      mobile: '',
                      whatsapp_number: '',
                      password: '',
                      address_line1: '',
                      address_line2: '',
                      city: '',
                      state: '',
                      country: '',
                      zip_code: '',
                      linkedin_link: '',
                      resume: '',
                      windows: false,
                      red_hat: false,
                      suse: false,
                      ubuntu: false,
                      centos: false,
                      azure: false,
                      aws: false,
                      gcp: false,
                      wan: false,
                      aws_nw: false,
                      azure_nw: false,
                      gcp_nw: false,
                      azure_backup: false,
                      aws_backup: false,
                      gcp_backup: false,
                      backup_other: false,
                      sql: false,
                      oracle: false,
                      db2: false,
                      open_source: false,
                      sap: false,
                      oracle_erp: false,
                      web: false,
                      middleware: false,
                      powershell: false,
                      ansible: false,
                      chef: false,
                      terraform: false,
                      automation_other: false,
                      java: false,
                      vb: false,
                      html: false,
                      backup_other_text: '',
                      open_source_text: '',
                      automation_other_text: '',
                      certifications: [],
                    });
                  }}
                >
                  Reset
                </button>
              )}
              <div className="err-msg">{status.errMsg}</div>
            </div>

            {data.status && (
              <div className="show-status">
                <label>Status:</label> <label>{data.status}</label>
              </div>
            )}
            <div className="divider">
              <div style={{ background: 'rgba(168, 217, 179, 0.78)' }}></div>
              <div style={{ background: 'rgba(235, 210, 179, 0.78)' }}></div>
            </div>
            <>
              <div className="content">
                <div className="line">
                  <div className="control">
                    <label>Email Address*</label>
                    <input
                      value={data.email}
                      className="text-ctrl"
                      type="email"
                      onChange={e =>
                        setData({ ...data, email: e.target.value })
                      }
                    ></input>
                  </div>

                  <div className="control">
                    <label>Position Applying</label>
                    <select
                      value={data.position_applying}
                      onChange={e =>
                        setData({
                          ...data,
                          position_applying: e.target.value,
                        })
                      }
                      className="text-ctrl"
                    >
                      <option value=""> --Select-- </option>
                      <option value="Windows Systems Administrator">
                        Windows Systems Administrator
                      </option>
                      <option value="Redhat Linux Administrator">
                        Redhat Linux Administrator
                      </option>
                      <option value="SUSE Linux Adminstrator">
                        SUSE Linux Adminstrator
                      </option>
                      <option value="Azure Network Engineer">
                        Azure Network Engineer
                      </option>
                      <option value="AWS Network Engineer">
                        AWS Network Engineer
                      </option>
                      <option value="GCP Network Engineer">
                        GCP Network Engineer
                      </option>
                      <option value="Azure Cloud Administrator">
                        Azure Cloud Administrator
                      </option>
                      <option value="AWS Cloud Administrator">
                        AWS Cloud Administrator
                      </option>
                      <option value="Serverless & Containers Engineer">
                        Serverless & Containers Engineer
                      </option>
                      <option value="Ansible Developer">
                        Ansible Developer
                      </option>
                      <option value="Terraform Engineer">
                        Terraform Engineer
                      </option>
                      <option value="Others">Others</option>
                    </select>
                  </div>

                  <div className="control">
                    <label>State Other Position </label>
                    <input
                      value={data.state_other_position}
                      disabled={data.position_applying !== 'Others'}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({
                          ...data,
                          state_other_position: e.target.value,
                        })
                      }
                    ></input>
                  </div>
                </div>

                <div className="line">
                  <div className="control">
                    <label>First Name</label>
                    <input
                      className="text-ctrl"
                      type="text"
                      value={data.first_name}
                      onChange={e =>
                        setData({ ...data, first_name: e.target.value })
                      }
                    ></input>
                  </div>

                  <div className="control">
                    <label>Middle Name</label>
                    <input
                      value={data.middle_name}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({ ...data, middle_name: e.target.value })
                      }
                    ></input>
                  </div>

                  <div className="control">
                    <label>Last Name</label>
                    <input
                      value={data.last_name}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({ ...data, last_name: e.target.value })
                      }
                    ></input>
                  </div>
                </div>

                <div className="line">
                  <div className="control">
                    <label>Mobile Number</label>
                    <div className="group">
                      {/* <select
                        value={data.country_code}
                        className="text-ctrl joint"
                        onChange={e =>
                          setData({ ...data, country_code: e.target.value })
                        }
                      >
                        <option value="">+XX</option>
                        {countrycodes.map(o => (
                          <option value={o.dial_code}>{o.dial_code}</option>
                        ))}
                      </select> */}

                      <Select
                        className="text-ctrl joint r-select"
                        placeholder="--Select--"
                        options={options}
                        value={{
                          label: data.country_code,
                          value: data.country_code,
                        }}
                        onChange={handleCountryCode}
                      ></Select>
                      <input
                        value={data.mobile}
                        className="text-ctrl"
                        type="text"
                        onChange={e =>
                          setData({ ...data, mobile: e.target.value })
                        }
                      ></input>
                    </div>
                  </div>
                  <div className="control">
                    <label>WhatsApp Number</label>
                    <input
                      value={data.whatsapp_number}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({ ...data, whatsapp_number: e.target.value })
                      }
                    ></input>
                  </div>
                  {/* <div className="control">
                  <label>Password</label>
                  <input className="text-ctrl" type="password"></input>
                </div> */}
                </div>

                <div className="line">
                  <div className="control">
                    <label>Address Line 1</label>
                    <input
                      value={data.address_line1}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({ ...data, address_line1: e.target.value })
                      }
                    ></input>
                  </div>
                  <div className="control">
                    <label>Address Line 2</label>
                    <input
                      value={data.address_line2}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({ ...data, address_line2: e.target.value })
                      }
                    ></input>
                  </div>

                  <div className="control">
                    <label>City</label>
                    <input
                      value={data.city}
                      className="text-ctrl"
                      type="text"
                      onChange={e => setData({ ...data, city: e.target.value })}
                    ></input>
                  </div>
                </div>

                <div className="line">
                  <div className="control">
                    <label>State</label>
                    <input
                      value={data.state}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({ ...data, state: e.target.value })
                      }
                    ></input>
                  </div>
                  <div className="control">
                    <label>Country</label>
                    <input
                      value={data.country}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({ ...data, country: e.target.value })
                      }
                    ></input>
                  </div>

                  <div className="control">
                    <label>Zip Code</label>
                    <input
                      value={data.zip_code}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({ ...data, zip_code: e.target.value })
                      }
                    ></input>
                  </div>
                </div>
              </div>

              <div className="divider">
                <div style={{ background: 'rgba(168, 217, 179, 0.78)' }}></div>
                <div style={{ background: 'rgba(235, 210, 179, 0.78)' }}></div>
              </div>

              <div className="content">
                <div className="line">
                  <div className="control">
                    <label>LinkedIn Profile Address</label>
                    <input
                      value={data.linkedin_link}
                      className="text-ctrl"
                      type="text"
                      onChange={e =>
                        setData({ ...data, linkedin_link: e.target.value })
                      }
                    ></input>
                  </div>
                </div>

                <div className="line">
                  <div className="control">
                    <label>Certifications</label>
                    <input
                      value={cert.name}
                      className="text-ctrl"
                      type="text"
                      value={cert.name}
                      onChange={e => setCert({ ...cert, name: e.target.value })}
                    ></input>
                  </div>
                  <div className="control">
                    <label>Certifications ID’s</label>
                    <input
                      value={cert.id}
                      className="text-ctrl"
                      type="text"
                      value={cert.id}
                      onChange={e => setCert({ ...cert, id: e.target.value })}
                    ></input>
                  </div>

                  <div className="control w-auto">
                    <button
                      disabled={!(cert.name && cert.id)}
                      onClick={() => {
                        if (cert.name && cert.id) {
                          setList([...list, cert]);
                          setCert({ id: '', name: '' });
                        }
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>

                {list.length > 0 && (
                  <div className="line">
                    <div className="control">
                      <label>Certification List</label>

                      <ul>
                        {list.map((x, i) => (
                          <li key={`list${i}`}>
                            <div>
                              <div className="head">ID</div>
                              <div className="id">{x.id}</div>
                            </div>
                            <div>
                              <div className="head">name</div>
                              <div className="name">{x.name}</div>
                            </div>
                            <div
                              className="close"
                              onClick={() => handleRemove(x)}
                            >
                              x
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                <div className="line">
                  <div className="control">
                    <label>Resume Attach</label>
                    {data.resume ? (
                      <div className="file-uploaded">
                        <div>File Uploaded</div>
                        <div>
                          <a href={data.resume} download="resume">
                            Download
                          </a>
                        </div>
                      </div>
                    ) : (
                      <input
                        className="text-ctrl"
                        type="file"
                        onChange={e => setUpload(e.target.files[0])}
                      ></input>
                    )}
                  </div>
                  <div className="control w-auto">
                    {!data.resume && (
                      <button disabled={!upload} onClick={handleUpload}>
                        Upload
                      </button>
                    )}{' '}
                  </div>
                  <div className="control">
                    {/* <label>Notes</label>
                  <input className="text-ctrl" type="text"></input> */}
                  </div>
                </div>
              </div>

              <div className="divider">
                <div style={{ background: 'rgba(168, 217, 179, 0.78)' }}></div>
                <div style={{ background: 'rgba(235, 210, 179, 0.78)' }}></div>
              </div>

              <div className="sub-title">Experience & Knowledge</div>

              <div className="content">
                <div className="line-check h-auto">
                  <div className="label-title">OS</div>
                </div>
                <div className="line-check">
                  <label className="label">
                    <input
                      checked={data.windows}
                      type="checkbox"
                      onChange={e =>
                        setData({ ...data, windows: e.target.checked })
                      }
                    ></input>
                    Windows
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.red_hat}
                      onChange={e =>
                        setData({ ...data, red_hat: e.target.checked })
                      }
                    ></input>
                    Red Hat
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.suse}
                      onChange={e =>
                        setData({ ...data, suse: e.target.checked })
                      }
                    ></input>
                    SUSE
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.ubuntu}
                      onChange={e =>
                        setData({ ...data, ubuntu: e.target.checked })
                      }
                    ></input>
                    Ubuntu
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.centos}
                      onChange={e =>
                        setData({ ...data, centos: e.target.checked })
                      }
                    ></input>
                    CentOS
                  </label>
                </div>

                <div className="line-check h-auto">
                  <div className="label-title">Cloud Platform</div>
                </div>
                <div className="line-check">
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.azure}
                      onChange={e =>
                        setData({ ...data, azure: e.target.checked })
                      }
                    ></input>
                    Azure
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.aws}
                      onChange={e =>
                        setData({ ...data, aws: e.target.checked })
                      }
                    ></input>
                    AWS
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.gcp}
                      onChange={e =>
                        setData({ ...data, gcp: e.target.checked })
                      }
                    ></input>
                    GCP
                  </label>
                </div>
                <div className="line-check h-auto">
                  <div className="label-title">Networking</div>
                </div>
                <div className="line-check">
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.wan}
                      onChange={e =>
                        setData({ ...data, wan: e.target.checked })
                      }
                    ></input>
                    WAN
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.aws_nw}
                      onChange={e =>
                        setData({ ...data, aws_nw: e.target.checked })
                      }
                    ></input>
                    AWS N/W
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.azure_nw}
                      onChange={e =>
                        setData({ ...data, azure_nw: e.target.checked })
                      }
                    ></input>
                    Azure N/W
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.gcp_nw}
                      onChange={e =>
                        setData({ ...data, gcp_nw: e.target.checked })
                      }
                    ></input>
                    GCP N/W
                  </label>
                </div>
                <div className="line-check h-auto">
                  <div className="label-title">Backup S/w</div>
                </div>
                <div className="line-check">
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.azure_backup}
                      onChange={e =>
                        setData({ ...data, azure_backup: e.target.checked })
                      }
                    ></input>
                    Azure backup
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.aws_backup}
                      onChange={e =>
                        setData({ ...data, aws_backup: e.target.checked })
                      }
                    ></input>
                    AWS backup
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.gcp_backup}
                      onChange={e =>
                        setData({ ...data, gcp_backup: e.target.checked })
                      }
                    ></input>
                    GCP backup
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.backup_other}
                      onChange={e =>
                        setData({ ...data, backup_other: e.target.checked })
                      }
                    ></input>
                    Other
                  </label>
                  {data.backup_other && (
                    <label className="label">
                      <input
                        value={data.backup_other_text}
                        type="text"
                        onChange={e =>
                          setData({
                            ...data,
                            backup_other_text: e.target.value,
                          })
                        }
                      ></input>
                    </label>
                  )}
                </div>
                <div className="line-check h-auto">
                  <div className="label-title">DB</div>
                </div>
                <div className="line-check">
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.sql}
                      onChange={e =>
                        setData({ ...data, sql: e.target.checked })
                      }
                    ></input>
                    SQL
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.oracle}
                      onChange={e =>
                        setData({ ...data, oracle: e.target.checked })
                      }
                    ></input>
                    Oracle
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.db2}
                      onChange={e =>
                        setData({ ...data, db2: e.target.checked })
                      }
                    ></input>
                    DB2
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.open_source}
                      onChange={e =>
                        setData({ ...data, open_source: e.target.checked })
                      }
                    ></input>
                    Open Source
                  </label>
                  {data.open_source && (
                    <label className="label">
                      <input
                        type="text"
                        value={data.open_source_text}
                        onChange={e =>
                          setData({
                            ...data,
                            open_source_text: e.target.value,
                          })
                        }
                      ></input>
                    </label>
                  )}
                </div>
                <div className="line-check h-auto">
                  <div className="label-title">Application</div>
                </div>
                <div className="line-check">
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.sap}
                      onChange={e =>
                        setData({ ...data, sap: e.target.checked })
                      }
                    ></input>
                    SAP
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.oracle_erp}
                      onChange={e =>
                        setData({ ...data, oracle_erp: e.target.checked })
                      }
                    ></input>
                    Oracle ERP
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.web}
                      onChange={e =>
                        setData({ ...data, web: e.target.checked })
                      }
                    ></input>
                    Web
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.middleware}
                      onChange={e =>
                        setData({ ...data, middleware: e.target.checked })
                      }
                    ></input>
                    Middleware
                  </label>
                </div>
                <div className="line-check h-auto">
                  <div className="label-title">Automation</div>
                </div>
                <div className="line-check">
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.powershell}
                      onChange={e =>
                        setData({ ...data, powershell: e.target.checked })
                      }
                    ></input>
                    Powershell
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.ansible}
                      onChange={e =>
                        setData({ ...data, ansible: e.target.checked })
                      }
                    ></input>
                    Ansible
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.chef}
                      onChange={e =>
                        setData({ ...data, chef: e.target.checked })
                      }
                    ></input>
                    Chef
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.terraform}
                      onChange={e =>
                        setData({ ...data, terraform: e.target.checked })
                      }
                    ></input>
                    Terraform
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.automation_other}
                      onChange={e =>
                        setData({
                          ...data,
                          automation_other: e.target.checked,
                        })
                      }
                    ></input>
                    Other
                  </label>
                  {data.automation_other && (
                    <label className="label">
                      <input
                        value={data.automation_other_text}
                        type="text"
                        onChange={e =>
                          setData({
                            ...data,
                            automation_other_text: e.target.value,
                          })
                        }
                      ></input>
                    </label>
                  )}
                </div>
                <div className="line-check h-auto">
                  <div className="label-title">Programming</div>
                </div>
                <div className="line-check">
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.java}
                      onChange={e =>
                        setData({ ...data, java: e.target.checked })
                      }
                    ></input>
                    Java
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.vb}
                      onChange={e => setData({ ...data, vb: e.target.checked })}
                    ></input>
                    VB
                  </label>
                  <label className="label">
                    <input
                      type="checkbox"
                      checked={data.html}
                      onChange={e =>
                        setData({ ...data, html: e.target.checked })
                      }
                    ></input>
                    HTML
                  </label>
                </div>
              </div>
              <div className="text-center">
                <button onClick={handleSave} disabled={loading}>
                  {loading ? 'Loading..' : 'SUBMIT'}
                </button>
              </div>
            </>

            {message.msg && (
              <div
                className={
                  message.success ? 'msg success-text' : 'msg error-text'
                }
              >
                {message.msg}
              </div>
            )}
          </GlobalWrapper>
        </Fade>
      </Container>
    </>
  );
};

export default GlobalCitizen;
